import { render, staticRenderFns } from "./configQuotation.vue?vue&type=template&id=7e806af0&scoped=true&"
import script from "./configQuotation.vue?vue&type=script&lang=js&"
export * from "./configQuotation.vue?vue&type=script&lang=js&"
import style0 from "./configQuotation.vue?vue&type=style&index=0&id=7e806af0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e806af0",
  null
  
)

export default component.exports